<p class="limits" *ngIf="min && max">
  <span>
    {{ "CreditCard.Min" | translate }} =&nbsp;
    <strong class="Saudi_Riyal" style="float: inline-end;">{{ "Currency."+currency  | translate }} {{ min | currencyFormat }}</strong>
  </span > <!--{{ addComma(min.toString() || "") }}-->
  <span>{{ "CreditCard.Max" | translate }} =&nbsp;
    <strong class="Saudi_Riyal" style="float: inline-end;">{{ "Currency."+currency  | translate }} {{ max | currencyFormat }}</strong>
  </span > <!--{{ addComma(min.toString() || "") }}-->
</p>
<div class="currency-container fw-normal" [class.ng-invalid]="maxExceeded || minExceeded">
  <input
    type="text"
    inputmode="numeric"
    class="form-control Saudi_Riyal "
    id="CurrencyInput{{ rand }}"
    name="CurrencyInputName{{ rand }}"
    #input
    (input)="format(input.value)"
    value="{{ value | currencyFormat}}"
    [readOnly]="readOnly"
  /> <!--[value]="addComma(value)"-->
  <p class="currency-name Saudi_Riyal">{{ "Currency."+currency  | translate }} </p>
</div>
<div style="min-height: 25px; margin-top: 8px">
  <p *ngIf="maxExceeded" style="text-align: start; color: red; font-size: 12px">
    {{ "Errors.MaxVal" | translate }} {{ max | currencyFormat }}
  </p>
  <p *ngIf="minExceeded" style="text-align: start; color: red; font-size: 12px">
    {{ "Errors.MinVal" | translate }} {{ min | currencyFormat }}
  </p>
</div>
